import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "../lib/api";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";

export const BlogCard = ({ p, big = false }) => (
  <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block">
    <div className={`relative overflow-hidden rounded-md ${big ? "aspect-[16/10]" : "aspect-[16/11]"} bg-[#0A0A0A]`}>
      {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover saturate-[0.8] group-hover:scale-105 group-hover:saturate-100 transition-all duration-700" />}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
      <div className="absolute top-4 left-4 flex gap-2">
        {(p.tags || []).slice(0, 2).map((t) => <span key={t} className="font-mono text-[9px] uppercase tracking-wider bg-white/90 text-[#0A0A0A] px-2 py-1 rounded">{t}</span>)}
      </div>
      <span className="absolute bottom-4 right-4 w-10 h-10 rounded-full bg-[#F5D5B0] text-[#0A0A0A] flex items-center justify-center translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300"><ArrowUpRight size={18} /></span>
    </div>
    <p className="mt-5 font-mono text-[10px] uppercase tracking-wider text-gray-400">{p.read_time} min read · {new Date(p.timestamp).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</p>
    <h3 className={`mt-2 font-heading font-bold text-[#0A0A0A] tracking-tight group-hover:text-[#6B1414] transition-colors ${big ? "text-2xl sm:text-3xl" : "text-xl"}`}>{p.title}</h3>
    <p className="mt-2 font-body text-sm text-[#6B7280] leading-relaxed line-clamp-2">{p.excerpt}</p>
  </Link>
);

export default function BlogPreview() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data.slice(0, 3))).catch(() => {}); }, []);
  if (!posts.length) return null;
  const [first, ...rest] = posts;

  return (
    <section id="insights" className="py-28 bg-white border-b border-[#E5E5E5]" data-testid="blog-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
          <div>
            <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#6B1414]">11 / Insights</span>
            <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-black tracking-[-0.03em] text-[#0A0A0A] leading-[0.95]">Playbooks from the floor.</h2>
          </div>
          <Link to="/blog" data-testid="blog-view-all" className="inline-flex items-center gap-2 font-body font-bold text-sm text-[#0A0A0A] border-b-2 border-[#6B1414] pb-1 hover:text-[#6B1414]">All articles <ArrowUpRight size={16} /></Link>
        </Reveal>
        <Stagger className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <StaggerItem className="lg:col-span-7"><BlogCard p={first} big /></StaggerItem>
          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-10">
            {rest.map((p) => <StaggerItem key={p.id}><BlogCard p={p} /></StaggerItem>)}
          </div>
        </Stagger>
      </div>
    </section>
  );
}
